<template>
  <div id="top_banner">
    <v-parallax dark src="../../assets/images/paralax.webp">
    <v-row >
        <v-col class="text-center" cols="12">    <p class="text-md-h5 text-h6 text-uppercase pl-10">программирование <br> графика и дизайн</p> </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" sm="6">
          <p class="text-uppercase">шаг в правильном <br />направлении</p>
          <v-btn to="/signUp" color="alert" class="white--text">
            Записаться
          </v-btn>
        </v-col>
        <v-col class="text-center" cols="12" sm="6">
            
          <p class="text-md-h5 text-h6 text-uppercase">успех детей в ваших руках</p>
          <p class="text-md-h6 text-subtitle-2">программист и дизайнер престижная профессия</p>
        </v-col>
      </v-row>
    </v-parallax>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.v-btn {
  margin-top: 20px;
  animation: btn_scale 5s ease infinite;
}

</style>